import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { FormField } from './form-field';


enum TYPES {

  input = 1,
  checkbox = 2,
  number = 3,
  dropdown = 4,
  textbox = 5

}

@Injectable({
  providedIn: 'root'
})
export class FormControlService {


  form: FormGroup;
  payload: string;


  constructor() { }

  setForm(form: FormGroup) {
    this.form = form;
  }

  getData(): string {
    return JSON.stringify(this.form.getRawValue());
  }



  toFormGroup(inputs: FormField<string>[], pictures: FormField<string>[]): FormGroup {
    const group: any = {};

    inputs.forEach(input => {
      let validator: ValidatorFn[] = input.required ? [Validators.required] : [];
      switch (input.validator) {
        case "email":
          validator.push(Validators.email);
          break;
        default:
          break;
      }
      group[input.key] = validator.length > 0 ? new FormControl(input.value || '', validator)
                                        : new FormControl(input.value || '');
    });

    pictures.forEach(input => {
      let validator: ValidatorFn[] = input.required ? [Validators.required] : [];
      switch (input.validator) {
        case "email":
          validator.push(Validators.email);
          break;
        default:
          break;
      }
      group[input.key] = validator.length > 0 ? new FormControl(input.value || '', validator)
                                        : new FormControl(input.value || '');
    });



    console.log(group);
    return new FormGroup(group);
  }

  getFormFields(tjson: any, pics: any, data? : any) {


    if(data){
      console.log(data);
    }

    let theJson = JSON.parse(tjson);
    //let thePicJson = JSON.parse(pics);

    console.log(theJson);
    const inputs: FormField<string>[] = []


    theJson.fields.forEach((e, index)=> {

      //console.log(data)
      inputs.push (
        new FormField<string>({
        controlType: e.inpt,
        key: 'field' + index,
        label: e.descr,
        options: e.choices,
        value: data ? data[`field${index}`] : ''
      }));

    })

    pics.forEach((e, index)=> {

      inputs.push (
        new FormField<string>({
        controlType: e.inpt,
        key: 'field' + index + '_pic',
        label: e.descr,
        options: e.choices,
        value: data ? data[`field${index}_pic`] : ''
      }));

    })



    console.log(inputs);
    return of(inputs);

    /*
    const inputs: FormField<string>[] = [

      new FormField<string>({
        controlType: "textbox",
        key: 'name',
        label: 'Name',
        required: false,
        order: 1
      }),

      new FormField<string>({
        controlType: "textbox",
        key: 'email',
        label: 'Email',
        type: 'email',
        required: false,
        validator: "email",
        order: 2
      }),

      new FormField<string>({
        controlType: "dropdown",
        key: 'country',
        label: 'Country',
        options: [
          {key: 'usa',  value: 'United States of America'},
          {key: 'br',  value: 'Brazil'},
          {key: 'other',   value: 'Other'}
        ],
        order: 3
      }),

      new FormField<string>({
        controlType: "checkbox",
        key: 'agree',
        label: 'I accept terms and services',
        type: 'checkbox',
        required: true,
        order: 4
      }),

      new FormField<string>({
        controlType: "radio",
        key: 'sex',
        label: 'Sex',
        type: 'radio',
        options: [
          {key: 'male',  value: 'Male'},
          {key: 'female',  value: 'Female'}
        ],
        order: 5
      }),

      new FormField<string>({
        controlType: "textarea",
        key: 'message',
        label: 'Mesage',
        type: 'textarea',
        order: 6
      })
    ];
*/
    //return of(inputs.sort((a, b) => a.order - b.order));
  }

}
